import {css, useTheme} from '@mui/material';
import {DlMuiTextField, GetStylesFunction, GetStylesOptions} from '@wallaby-ui/core';
import * as React from 'react';
import {InputGroup} from 'react-bootstrap';

import FilterNodeTypeTextInput from './FilterNodeTypeTextInput';

interface OwnProps {
  inputRef: (inputElement: HTMLInputElement) => void;
  isOpened?: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => boolean;
  value: string;
  searchPrefix: string;
  label: string;
  isMui?: boolean;
  wrapperWidth?: string;
  inputWidth?: string;
  /** Icon at the end of the empty field, any name from src/assets/icons; the magnifier unless said otherwise. */
  iconName?: string;
}

type Props = OwnProps;

export const FilterNodeTypeText: React.FC<Props> = (props) => {
  const {searchPrefix, handleChange, handleKeyDown, isOpened, inputRef, value, isMui, label, wrapperWidth, inputWidth, iconName} = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {wrapperWidth, inputWidth}});

  // TODO: add filter wrapper (move div from DlMuiTextField here - see FilterNodeTypeSelect)
  const muiTextFieldComponent = (
    <div css={styles.textFieldWrapper}>
      <DlMuiTextField
        label={label}
        searchPrefix={searchPrefix}
        iconName={iconName ?? 'searchIcon'}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        variant={'outlined'}
        inputRef={inputRef}
        value={value}
        inputCss={styles.textField}
      />
    </div>
  );
  const textFieldComponent = searchPrefix ? (
    <InputGroup>
      <InputGroup.Text>{searchPrefix}</InputGroup.Text>
      <FilterNodeTypeTextInput handleChange={handleChange} inputRef={inputRef} isOpened={isOpened} value={value} />
    </InputGroup>
  ) : (
    <FilterNodeTypeTextInput handleChange={handleChange} inputRef={inputRef} isOpened={isOpened} value={value} />
  );

  return isMui ? muiTextFieldComponent : textFieldComponent;
};

FilterNodeTypeText.displayName = 'FilterNodeTypeText';

const getStyles: GetStylesFunction = (options?: GetStylesOptions) => ({
  textFieldWrapper: css`
    display: flex;
    height: 53px;
    width: ${options?.params?.wrapperWidth ?? '176px'};
  `,
  textField: css`
    height: 38px;
    top: 8px;
    background: white;
    width: ${options?.params?.inputWidth};
  `,
});
